import { useState, useCallback } from 'react'
import useServiceIngressesResources from '../../shared/resources/api/v1/admin/docker/useServiceIngressesResources'

export default function useServiceIngressesState(teamSlug, projectSlug, serviceSlug) {
  const [ingresses, setIngresses] = useState([])
  const [loading, setLoading] = useState(true)

  const {
    all,
    create,
    update,
    destroy,
  } = useServiceIngressesResources(teamSlug, projectSlug, serviceSlug)

  const load = useCallback(() => {
    return all()
      .then((response) => setIngresses(response.ingresses || []))
      .catch(() => setIngresses([]))
      .finally(() => setLoading(false))
  }, [all])

  const refresh = useCallback(() => {
    return all()
      .then((response) => setIngresses(response.ingresses || []))
      .catch(() => setIngresses([]))
  }, [all])

  const createIngress = useCallback((data) => {
    return create(data).then(() => refresh())
  }, [create, refresh])

  const updateIngress = useCallback((id, data) => {
    return update(id, data).then(() => refresh())
  }, [update, refresh])

  const destroyIngress = useCallback((id) => {
    return destroy(id).then(() => refresh())
  }, [destroy, refresh])

  return {
    ingresses,
    loading,
    load,
    createIngress,
    updateIngress,
    destroyIngress,
  }
}
